import { NavigateTo } from "source/app/presentation/Routing/RouterNavigationTarget";
import { EPanelId } from "source/app/services/Shared/EPanelId";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { State } from "source/app/services/UI/State/State";
import { IActivePanelState } from "../IActivePanelState";
import { GetNavigationMenuItems } from "../NavigationMenu/NavigationMenuItems";

export function LoadPanel(panelId: EPanelId, onPanelShowArgs?: object) {
    const OnPanelShow = GetNavigationMenuItems().find(
        (item) => item.id === panelId
    )!.OnPanelShow;

    const activePanel = State.ReadClass<IActivePanelState>(
        ESharedComponent.ActivePanel
    );

    const targetPanelName = EPanelId[panelId];

    if (activePanel) {
        console.log(`[Routing] LoadPanel navigating to '${targetPanelName}'`);
        NavigateTo(`/${targetPanelName}`);

        if (OnPanelShow !== undefined) {
            OnPanelShow(onPanelShowArgs);
        }
    }
}
